import type { ScreenSchema } from './types';

/**
 * Schema for the `hotspot-game` template (screen-hotspot-game.vue).
 *
 * HSG uses bespoke ScrollTriggers and S3 marker keys that differ from the
 * default intro convention:
 *   - intro  → `${screen.id}_intro`
 *   - level  → `${screen.id}-level-${i}`  (iterated `level` slot)
 *   - result → `${screen.id}_result`       (resolved at runtime from activeResult)
 *
 * `managesOwnSectionAudio: true` — screen-hotspot-game.vue owns playback.
 */
const hotspotGameSchema: ScreenSchema = {
  template: 'hotspot-game',
  managesOwnSectionAudio: true,
  entryPrefetch: 'hotspot-game-entry',
  slots: {
    'intro-section': {
      markerKey: '${id}_intro',
      parts: [
        {
          iterateField: 'intro',
          itemKeyPath: 'intro',
          parts: [
            { field: 'heading', fallback: ['subheading', 'title'] },
            { field: 'text' },
            { field: 'instructions' }
          ]
        }
      ]
    },
    level: {
      iterate: 'levels',
      keyPrefix: 'level',
      markerKey: '${id}-level-${index}',
      parts: [
        { field: 'subheading', fallback: ['heading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};

export default hotspotGameSchema;
